import React, {Component} from "react";
import Label from "../Label/Label";
import T from "../t/T";
import "./RadioButton.scss";

class RadioButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options,
      selected: this.props.selected,
    };
  }

  onChange = (event) => {
    this.setState({selected: event}, ()=>{
      this.props?.onChange(event)
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selected !== this.props.selected) {
      this.setState({selected: this.props.selected});
    }
    if (prevProps.options !== this.props.options) {
      this.setState({options: this.props.options});
    }
  }

  render() {
    const { label = null, inputName = "", tabIndex=0} = this.props;

    return <div className="radio__inputs">
      { label && <Label labelText={label} />}
      {this.state.options.map((item, index) => {
        return ( <div className={`radio-face ${item.disabled ? "disabled" : ""} ${this.state.selected?.value === item.value ? "selected" : ""}`} onClick={()=>this.onChange(item)}>
            <span className={"icon"}> {this.state.selected?.value === item.value ? <i className="fas fa-dot-circle fa-"/> : <i className="fa fa-circle" />} </span>
            <input type="radio" name={inputName} checked={this.state.selected?.value === item.value} value={item.value ?? ""} onChange={() => {}} tabIndex={index}/>
            <span className={"radio__title__text"} >
              <T token={item.text}/>
            </span>
          </div> )
      })}
    </div>;
  }
}

export default RadioButton;
